import { observer } from 'mobx-react';

import styles from './GoogleButton.module.scss';

import { Icon, IconType } from '@components/Icon';

interface Props {
    label: string;
    onClick(event?: React.MouseEvent<HTMLDivElement>): void | Promise<void>;
}

export const GoogleButton = observer(({ label, onClick }: Props) => {
    return (
        <div
            className={styles.root}
            onClick={onClick}
        >
            <div className={styles.icon}>
                <Icon type={IconType.GOOGLE} />
            </div>
            <div>{label}</div>
        </div>
    );
});
